import { createMuiTheme } from "@material-ui/core/styles";

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#01244e",
      light: "#374b7a",
      dark: "#000026",
      contrastText: "#fff"
    },
    secondary: {
      main: "#26baec",
      light: "#70ecff",
      dark: "#008ab9",
      contrastText: "#fff"
    }
  }
});
